import { Icon } from 'components/Atoms/Icon/Icon';
import classNames from 'classnames';
import { useIsRTL } from 'utils/useIsRTL';
import { useTranslation } from 'react-i18next';
import styles from '../Timeline.module.scss';

export function ProgressCurrent() {
  const { isRTL } = useIsRTL();
  const { t } = useTranslation();

  return (
    <div className={classNames(styles.progress, styles.current)}>
      {!isRTL ? (
        <Icon height={24} width={24} name="arrow-right-thin" color="#fff" ariaLabel={t('icons.inprogress')} />
      ) : (
        <Icon height={24} width={24} name="arrow-left-thin" color="#fff" ariaLabel={t('icons.inprogress')} />
      )}
    </div>
  );
}
